import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { map , catchError} from 'rxjs/operators';
import { Location } from '@angular/common';
import { User } from 'src/app/Model/User/user.model';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

 //_url= 'http://localhost/MyAsset/api';
 //_url= 'http://multiinspectionreport.com/reception/api';
 //_url= 'https://test.appointele.com/api';
 //_url= 'https://demo.appointele.com/api';
 _url= 'https://ciot.appointele.com/api';
//_url= 'https://ciot.appointele.ca/api';
 
  allUsers=[];
  branchCategories=[];
  roleCategories=[];
  accessCategories=[];
  branchCount;
  userInfoDetails;
  userSiteAccess;
  performedByLog;
  performedOnLog;

  private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;

    constructor(private _location: Location,
      private _http: HttpClient) {
      //The logged in user details are stored in local storage so the user will stay logged in if they refresh the browser and also between browser sessions until they logout
      //is used to check if user is still logged in
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    
    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    /**login(username: string, password: string) {
    this._http.post<any>('https://yourdomain.com/authenticate.php', { username: username, password: password })
      .subscribe({
        next: (response) => {
          localStorage.setItem('api_url', response.api_url);
          console.log('Login successful');
          this.userlogin(username, password);
        },
        error: (error) => {
          console.error('Login failed', error);
        }
      }); 
    }**/
/***************************************************************************************** */
  login(username: string, password: string) { 
      console.log(username);
        return this._http.post<any>(`${this._url}/user_authentication.php`,{username, password})
            .pipe(map(user => {
            
     //        console.log(user);
       //      console.log(this._url);
             
                // login successful if there's a jwt token in the response
                if (user //&& user.token
                  ) {
                  //  localStorage.setItem('api_url', user.api_url);
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(user));
                    //(RxJs)Behaviour.next(user) method will get new value of user and will replace old value of user
                    this.currentUserSubject.next(user);
                   
                }
                window.location.reload();
                return user;
             
            }),
            catchError(this.handleError));
    }
/***************************************************************************************** */
    logout(userName) {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        //(RxJs)Behaviour.next(user) method will get new value of user to null by replacing old value of user 
        this.currentUserSubject.next(null);
    
        return this._http.get(`${this._url}/user_chat_logout.php?userName=${userName}`).pipe(
          map((res) => {
            //this.alltodaysapointment = res;
            //console.log(res);
            //return this.alltodaysapointment;
            return res;
        }),
      
        catchError(this.handleError));
       
              
    }






/***************************************************************************************** */
    getRoleCategoriesForForm(){
      return this._http.get(`${this._url}/role_categories_get.php`).pipe(
        map((res) => {
          this.roleCategories = Object.assign(res);
   //       console.log(this.roleCategories);
          return this.roleCategories;
      }),
      
      catchError(this.handleError));
    }



/***************************************************************************************** */
    register(registerForm){
      console.log(registerForm);
      return this._http.post<any>(`${this._url}/user_login_insert.php`, registerForm).pipe(
        map((res) => {
        
        console.log(res);
          return res;
        }),
        catchError(this.handleError));
    }
/***************************************************************************************** */
passwordReset(passwordResetForm){
  return this._http.post<any>(`${this._url}/user_login_password_reset_ByUserName.php`, passwordResetForm).pipe(
    map((res) => {
    //  console.log(res);
      return res;
    }),
    catchError(this.handleError));
}



/***************************************************************************************** */
    getAllUsers(){
      return this._http.get(`${this._url}/user_login_get_all.php`).pipe(
        map((res) => {
          this.allUsers = Object.assign(res);
  //        console.log(this.allUsers);
          return this.allUsers;
      }),
      
      catchError(this.handleError));
      }
  /***************************************************************************************** */      

    getUserByID(userNameQuery,){
      return this._http.get(`${this._url}/user_login_getByID.php?userName=${userNameQuery}`)
      .pipe(    map((res) => {
    //    console.log(res);
        this.userInfoDetails= res;
        if(this.userInfoDetails!=null){
      //  console.log(this.userInfoDetails);
        }
        return this.userInfoDetails;
    }),
    
    catchError(this.handleError));
    }
/***************************************************************************************** */
    getUserSiteAccessByID(userNameQuery){
      return this._http.get(`${this._url}/user_site_access_getByID.php?userName=${userNameQuery}`)
      .pipe(    map((res) => {
        console.log(res);
        this.userSiteAccess= res;
        if(this.userSiteAccess!=null){
    //    console.log(this.userSiteAccess);
        }
        return this.userSiteAccess;
    }),
    
    catchError(this.handleError));
    }

/***************************************************************************************** */
    individualExpertiseChange(expertiseForm){
      return this._http.post<any>(`${this._url}/user_login_expertise_change.php`, expertiseForm).pipe(
        map((res) => {
      //    console.log(res);
          return res;
        }),
        catchError(this.handleError));
    }
    
/***************************************************************************************** */
    individualRoleChange(roleChangeForm){
      return this._http.post<any>(`${this._url}/user_login_role_change.php`, roleChangeForm).pipe(
        map((res) => {
      //    console.log(res);
          return res;
        }),
        catchError(this.handleError));
    }
    
  /***************************************************************************************** */  

    menuAccess(userName,menuAccess){
      return this._http.get(`${this._url}/user_login_menu_access.php?userName=${userName}&menuAccess=${menuAccess}`).pipe(
        map((res) => {
       //   console.log(res[0]);
          return res[0];
        }),
        catchError(this.handleError));
    }

    /***************************************************************************************** */
    getAllBranchCount(){
      return this._http.get(`${this._url}/get_all_user_login_branch_count.php`).pipe(
        map((res) => {
          this.branchCount = res;
          return this.branchCount;
        })
      );
    }


/***************************************************************************************** */
    deleteUserByID(users){
    //  console.log(users);
      
      return this._http.post<any>(`${this._url}/user_login_deleteByID.php`,users);
    }


/***************************************************************************************** */
    getAccessCategoriesForForm(){
      return this._http.get(`${this._url}/access_categories_get.php`).pipe(
        map((res) => {
          this.accessCategories = Object.assign(res);
       //   console.log(this.accessCategories);
          return this.accessCategories;
      }),
      
      catchError(this.handleError));
    }

/***************************************************************************************** */

    individualStatusChange(statusChangeForm) {
      return this._http.post(`${this._url}/user_login_status_change.php`, statusChangeForm).pipe(map((res) => {
      //    console.log(res);
          return res;
      }), catchError(this.handleError));
  }
/***************************************************************************************** */
  
  individualBranchChange(roleChangeForm) {
      return this._http.post(`${this._url}/user_login_branch_change.php`, roleChangeForm).pipe(map((res) => {
     //     console.log(res);
          return res;
      }), catchError(this.handleError));
  }

/***************************************************************************************** */

    getBranchCategoriesForForm(){
      return this._http.get(`${this._url}/branch_categories_get.php`).pipe(
        map((res) => {
          this.branchCategories = Object.assign(res);
      //    console.log(this.branchCategories);
          return this.branchCategories;
      }),
      
      catchError(this.handleError));
    }

/***************************************************************************************** */

    getLogsPerformedByUser(userName){
      return this._http.get(`${this._url}/user_login_log_performedBy_user.php?userName=${userName}`)
      .pipe(    map((res) => {
      //  console.log(res);
        this.performedByLog= res;
        if(this.performedByLog!=null){
      //  console.log(this.performedByLog);
        }
        return this.performedByLog;
      }),
    
      catchError(this.handleError));
      }
/***************************************************************************************** */


      getLogsPerformedOnUser(userName){
        return this._http.get(`${this._url}/user_login_log_performedOn_user.php?userName=${userName}`)
        .pipe(    map((res) => {
         // console.log(res);
          this.performedOnLog= res;
          if(this.performedOnLog!=null){
        //  console.log(this.performedOnLog);
          }
          return this.performedOnLog;
        }),
      
        catchError(this.handleError));
        }
  
  

 /*********************************************************************************** */

 updateUser(userEditForm){
  return this._http.post<any>(`${this._url}/user_login_update.php`, userEditForm).pipe(
    map((res) => {
    
    
      return res;
    }),
    catchError(this.handleError));
}


    private handleError(error: HttpErrorResponse) {
      console.log(error.error);
     //console.error('Full error response:', error);  // Log the full error for inspection
      // return an observable with a user friendly message
      return throwError(error.error.text);
    }
    


}